import { ResourceType } from '../../enumerations/ResourceType';
import { AddOrSetMutateObject, AddOrSetMutateObjectSchema, BatchAddMutateObject, BatchAddMutateObjectSchema } from '../mutateObjects';
import { ParentedPersistableResource, PersistableSchemaType } from '../persistableResourceTypes';
import { useMutationWithDelay } from '../useMutationWithDelay';
import { useMultiResourceSingleParentedResourceAdapterBaseActions } from './useMultiResourceSingleParentedResourceAdapterBaseActions';

export function useMultiResourceSingleParentedResourceAdapterActions<R extends ParentedPersistableResource>(
    apiPostfix: string,
    resourceType: ResourceType,
    resourceSchema: PersistableSchemaType<R>
) {
    const actions = useMultiResourceSingleParentedResourceAdapterBaseActions(apiPostfix, resourceType, resourceSchema);

    const useBatchAddResource = () => {
        return useMutationWithDelay((mutateObject: BatchAddMutateObject<R>) => actions.batchAddResource(mutateObject.payload), BatchAddMutateObjectSchema);
    };

    const useAddResource = () => {
        return useMutationWithDelay(
            (mutateObject: AddOrSetMutateObject<R>) => actions.addOrSetResource(mutateObject.resource, mutateObject.parentId as string),
            AddOrSetMutateObjectSchema
        );
    };

    return {
        useValidateResource: actions.useValidateResource,
        useGetDependencyValidation: actions.useGetDependencyValidation,
        useValidateAllResourcesSingleParented: actions.useValidateAllResourcesSingleParented,
        useGetResource: actions.useGetResource,
        useUpdateResource: actions.useUpdateResource,
        useDeleteResource: actions.useDeleteResource,
        useGetAllResources: actions.useGetAllResources,
        useGetUnusedIds: actions.useGetUnusedIds,
        processMutationResponse: actions.processMutationResponse,
        processGetResponse: actions.processGetResponse,
        processGetCollectionResponse: actions.processGetCollectionResponse,
        processGetResourceResponse: actions.processGetResourceResponse,
        useAddResource,
        useBatchAddResource,
    };
}
